// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qR","innerWrapper":"rR"};